<template>
  <div class="boss-page">
    <van-nav-bar title="全公司效能热力图" left-arrow @click-left="$router.back()"/>
    <section class="month">
      <button @click="change(-1)">
        <van-icon name="arrow-left"/>
      </button>
      <b>{{ month.replace('-', ' 年 ') }} 月</b>
      <button @click="change(1)">
        <van-icon name="arrow"/>
      </button>
    </section>
    <van-skeleton v-if="loading" title :row="9"/>
    <main v-else>
      <article v-for="item in data.cells||[]" :key="item.departmentName+item.positionName" :class="['cell',item.level]">
        <header><span><b>{{ item.departmentName }}</b><small>{{ item.positionName }}</small></span><strong>{{ num(item.averageScore) }}</strong>
        </header>
        <div>
          <span>人数 {{ item.employees }}</span><span>已提交 {{ item.submittedEmployees }}</span><span>提交率 {{ num(item.submissionRate) }}%</span>
        </div>
      </article>
      <van-empty v-if="!(data.cells||[]).length" description="暂无公司绩效数据"/>
    </main>
  </div>
</template>
<script>
/** Boss 全公司效能热力图：按部门×岗位展示均分与提交率，cell.level 标识关注等级 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    const d = new Date();
    return {month: this.$route.query.month || `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, data: {}, loading: false}
  }, mounted() {
    this.load()
  }, methods: {
    num(v) {
      return Number(v || 0).toFixed(1)
    }, async load() {
      this.loading = true;
      try {
        this.data = await coreapi.bossHeatmap(this.month)
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }, change(n) {
      const p = this.month.split('-'), d = new Date(+p[0], +p[1] - 1 + n, 1);
      this.month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      this.load()
    }
  }
}</script>
<style lang="less" scoped>@import './boss.less';

.cell {
  border-left: .08rem solid @color
}

.cell.WATCH {
  border-color: #D32F2F
}

.cell.RISK {
  border-color: #D32F2F
}

.cell header {
  display: flex;
  justify-content: space-between
}

.cell b, .cell small {
  display: block
}

.cell small {
  margin-top: .06rem;
  color: #9295a7
}

.cell strong {
  color: @color;
  font-size: .42rem
}

.cell > div {
  margin-top: .18rem;
  display: flex;
  justify-content: space-between;
  color: #777b90;
  font-size: .23rem
}</style>



// WEBPACK FOOTER //
// src/views/boss/Heatmap.vue